import {
	Command,
	TextSelection,
	Transaction
} from "prosemirror-state";
import { isNotNil } from "client/Misc/utils";
import { range } from "client_legacy/ndaw/arrayHelpers";
import {
	Mark,
	Node as ProsemirrorNode,
	Schema
} from "prosemirror-model";
import { convertMarksToDefaultFontMarks } from "../plugins/defaultFontMarksPlugin";
import { SupportedDefaultFontMarks } from "../schema/nodes/attributes/defaultFontMarks";
import { ParagraphNodeAttributes } from "../schema/nodes/paragraph";

export function insertTable(
	schema: Schema<
		| "paragraph"
		| "table"
		| "table_cell"
		| "table_row",
		never
	>,
	rows: number,
	columns: number
): Command {
	return (state, dispatch): boolean => {
		if (dispatch) {
			const {
				$from
			} = state.selection;

			const marksAtSelection: readonly Mark[] = state.storedMarks
				?? $from.marks();

			const defaultFontMarks: SupportedDefaultFontMarks | null = convertMarksToDefaultFontMarks(
				marksAtSelection,
				schema
			);

			const paragraphAttributes: ParagraphNodeAttributes = {
				defaultFontMarks: defaultFontMarks ?? undefined,
				indention: undefined,
				textAlign: undefined
			};

			const {
				paragraph,
				table,
				table_cell,
				table_row
			} = schema.nodes;

			const firstCellParagraph: ProsemirrorNode = paragraph.create(
				paragraphAttributes
			);

			const tr: Transaction = state.tr;

			tr.replaceSelectionWith(
				table.create(
					null,
					range(rows)
						.map((row) => table_row.create(
							null,
							range(columns)
								.map((column) => table_cell.create(
									null,
									row === 0 && column === 0
										? firstCellParagraph
										: paragraph.create(paragraphAttributes)
								))
						))
				)
			);

			let firstParagraphPos: number | undefined;

			tr.doc
				.nodesBetween(
					$from.pos,
					Math.min(
						$from.pos + 10,
						tr.doc
							.nodeSize - 2
					),
					(node: ProsemirrorNode, pos: number): boolean | undefined => {
						if (node === firstCellParagraph) {
							firstParagraphPos = pos;
							return false;
						}

						return undefined;
					}
				);

			if (isNotNil(firstParagraphPos)) {
				tr.setSelection(TextSelection.create(tr.doc, firstParagraphPos + 1));
			}

			tr.scrollIntoView();
			dispatch(tr);
		}

		return true;
	};
}